// extracted by mini-css-extract-plugin
module.exports = {"container":"articles-carousel_container__x82Kb","box":"articles-carousel_box__U6byE","item":"articles-carousel_item__mRGsi"};